import React from "react";
import NavBar from "../components/homePage/navBar";
import HomeContent from "../components/homePage/homeContent";


const HomePage: React.FC = () => {
  return (
 <div>
    <NavBar />
    <HomeContent/>
  </div>
  );
};

export default HomePage;
